import React from 'react';
import ReactDOM from 'react-dom';
import {RouterProvider, BrowserHistory} from '@malectro/rerouter';
import {UserProvider} from './user';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './firebase';

ReactDOM.render(
  <React.StrictMode>
    <RouterProvider history={new BrowserHistory()}>
      <UserProvider>
      <App />
      </UserProvider>
    </RouterProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
